const extOfInjuryValues = {
  "1": "Apparent Death",
  "2": "Unconscious",
  "3": "Semi-Conscious",
  "4": "Incoherent",
  "5": "Shock",
  "6": "Conscious",
  "?": "Invalid Code",
  A: "Incapacitating Injury",
  B: "Non-incapacitating Injury",
  C: "Possible Injury",
  K: "Killed",
};

const accidentTypes = {
  "01": "Collision With Motor Vehicle",
  "02": "Collision With Pedestrian",
  "03": "Collision With Bicyclist",
  "04": "Collision With Animal",
  "05": "Collision With Railroad Train",
  "06": "Collision With In-Line Skater",
  "07": "Collision With Deer",
  "08": "Collision With Other Pedestrian",
  "10": "Collision With Other",
  "11": "Collision. W/Light Support/Utility Pole",
  "12": "Collision With Guide Rail",
  "13": "Collision With Crash Cushion",
  "14": "Collision With Sign Post",
  "15": "Collision With Tree",
  "16": "Collision With Building/Wall",
  "17": "Collision With Curbing",
  "18": "Collision With Fence",
  "19": "Collision With Bridge Structure",
  "20": "Collision With Culvert/Head Wall",
  "21": "Collision With Median/Barrier",
  "22": "Collision With Snow Embankment",
  "23": "Collision. W/Earth Element./Rock Cut/Ditch",
  "24": "Collision With Fire Hydrant",
  "25": "Collision With Guiderail End",
  "26": "Collision With Median Barrier End",
  "27": "Collision With Other Barrier",
  "30": "Collision With Other Fixed Object",
  "31": "Overturned",
  "32": "Fire/Explosion",
  "33": "Submersion",
  "34": "Ran Off Road Only",
  "40": "Other Non-Collision",
  XX: "Not Entered",
  YY: "Not Applicable",
  ZZ: "Unknown",
};

const functionalClassLookup = {
  1: "Rural Principal Arterial Interstate",
  2: "Rural Principal Arterial Freeway/Expressway",
  4: "Rural Principal Arterial Other",
  6: "Rural Minor Arterial",
  7: "Rural Major Collector",
  8: "Rural Minor Collector",
  9: "Rural Local",
  11: "Urban Principal Arterial Interstate",
  12: "Urban Principal Arterial Freeway/Expressway",
  14: "Urban Principal Arterial Other",
  16: "Urban Minor Arterial",
  17: "Urban Major Collector",
  18: "Urban Minor Collector",
  19: "Urban Local",
};

function decodeInjuries(code) {
  let response = "";
  if (code) {
    let count = 0;
    code.split("").forEach((letter) => {
      let comma = count > 0 ? ", " : "";
      response = response + comma + extOfInjuryValues[letter];
      count++;
    });
  }
  return response;
}

function mostSevereInjury(f) {
  let fk = { ...f };
  if (
    fk.properties.EXT_OF_INJURIES &&
    fk.properties.EXT_OF_INJURIES.indexOf("K") > -1
  ) {
    fk.properties.mostSevereInjury = "K";
  } else if (
    fk.properties.EXT_OF_INJURIES &&
    fk.properties.EXT_OF_INJURIES.indexOf("A") > -1
  ) {
    fk.properties.mostSevereInjury = "A";
  } else if (
    fk.properties.EXT_OF_INJURIES &&
    fk.properties.EXT_OF_INJURIES.indexOf("B") > -1
  ) {
    fk.properties.mostSevereInjury = "B";
  } else if (
    fk.properties.EXT_OF_INJURIES &&
    fk.properties.EXT_OF_INJURIES.indexOf("C") > -1
  ) {
    fk.properties.mostSevereInjury = "C";
  } else {
    fk.properties.mostSevereInjury = "D";
  }
  return fk;
}

function addEpochDates(f) {
  let fk = { ...f };
  fk.properties.accidentDateEpoch = f.properties.ACCD_TME_STR
    ? new Date(f.properties.ACCD_TME_STR).valueOf()
    : new Date(f.properties.ACCD_DTE).valueOf();
  return fk;
}

function parseParms(str) {
  var pieces = str.split("&"),
    data = {},
    i,
    parts;
  // process each query pair
  for (i = 0; i < pieces.length; i++) {
    parts = pieces[i].split("=");
    if (parts.length < 2) {
      parts.push("");
    }
    data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
  }
  return data;
}

export {
  accidentTypes,
  extOfInjuryValues,
  functionalClassLookup,
  decodeInjuries,
  mostSevereInjury,
  addEpochDates,
  parseParms,
};
